// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import convocationEntity from './entities/convocation.json';
import convocationMenu from '../pages/convocation/menu.json';
import convocationFullForm from '../pages/convocation/forms/full.json';
import convocationContextForm from '../pages/convocation/forms/context.json';
import convocationMiniForm from '../pages/convocation/forms/mini.json';
import convocationLookupForm from '../pages/convocation/forms/lookup.json';
import convocationTableView from '../pages/convocation/views/table.json';
import convocationStagesView from '../pages/convocation/views/stages.json';
import convocationCardsView from '../pages/convocation/views/cards.json';
import convocationInlineView from '../pages/convocation/views/inline.json';
import convocationBacklogView from '../pages/convocation/views/backlog.json';
import convocationSplitView from '../pages/convocation/views/split.json';
import convocationCalendarView from '../pages/convocation/views/calendar.json';
import convocationDashboardView from '../pages/convocation/views/dashboard.json';

/** Тип запису «Скликання» зі сторінками пакета: меню, форми та подання з pages/convocation/. */
export const convocationDefinition: IRecordTypeDefinition = {
  ...convocationEntity,
  views: assembleViewSet({
      table: convocationTableView,
      stages: convocationStagesView,
      cards: convocationCardsView,
      inline: convocationInlineView,
      backlog: convocationBacklogView,
      split: convocationSplitView,
      calendar: convocationCalendarView,
      dashboard: convocationDashboardView,
  }),
  form: convocationFullForm,
  forms: { full: convocationFullForm, context: convocationContextForm, mini: convocationMiniForm, lookup: convocationLookupForm },
  menu: convocationMenu,
} as IRecordTypeDefinition;
